<template>
  <div class="w-full h-full">
    <div class="tab-bar bg-gray-200 flex items-center">
      <button @click="$emit('toggle-fullscreen')" class="hidden lg:flex focus:outline-none rounded-full justify-center items-center text-sm bg-white px-4 border m-1">Toggle SideBar</button>
      <button @click="() => { if ($refs.editor) {  $refs.editor.$emit('toggle-editor'); } }" class="focus:outline-none rounded-full flex justify-center items-center text-sm bg-white px-4 border m-1">Toggle Editor</button>
      <button @click="() => { if ($refs.editor) {  $refs.editor.$emit('load-latest-code', { name: 'dancer' }); } }" class="flex focus:outline-none rounded-full justify-center items-center text-sm bg-white px-4 border m-1">Dancer eg</button>
      <button @click="() => { if ($refs.editor) {  $refs.editor.$emit('load-latest-code', { name: 'beach' }); } }" class="flex focus:outline-none rounded-full justify-center items-center text-sm bg-white px-4 border m-1">Beach eg</button>
    </div>

    <div class="tab-content">
      <O3DEditor ref="editor" :globals="{ MyOwnLib: 'my own lib' }" :NS="ns + 1" class="full"></O3DEditor>
    </div>
  </div>
</template>

<script>
export default {
  mixins: [
    require('../../Reusable/O3DCompos').O3DCompos
  ],
  data () {
    return {
      ns: require('raw-loader!../../Reusable/Editor/defaultcode-beach.txt').default
    }
  },
  mounted () {
    window.dispatchEvent(new Event('resize'))
  }
}
</script>

<style lang="postcss">
.tab-bar{
  height: 35px;
}
.tab-content{
  height: calc(100% - 35px);
}
</style>
